import { computed, onMounted, ref } from 'vue'

import type { DropdownOption } from '@/components/common/ui/inputs/inputTypes'
import type { EmployeeDynamic } from '@/types/external/2work/doctypes/generatorOutput/Setup/EmployeeDynamic'

import AvatarInitials from '@/components/common/ui/avatar/AvatarInitials.vue'
import {
  type EmployeeListParameterList,
  useFrappeNestCustomAPIStore,
} from '@/stores/apis/frappeNestCustomAPI'
import { getEmployeeImageUrl } from '@/utilities/employeeHelpers'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const useEmployeeOptions = () => {
  const customAPIStore = useFrappeNestCustomAPIStore()

  const employees = ref<EmployeeDynamic[]>([])

  const employeeOptions = computed((): DropdownOption<string | undefined>[] => {
    const options: DropdownOption<string | undefined>[] = employees.value
      .map((employee) => {
        const mapDropdownOption: DropdownOption<string> = {
          icon: AvatarInitials,
          image: getEmployeeImageUrl(employee.image, customAPIStore.showEmployeeImage) ?? undefined,
          optionLabel: employee.employee_name ?? '',
          optionValue: employee.name ?? '',
        }

        return mapDropdownOption
      })
      .filter((mapEmployee) => {
        return mapEmployee.optionLabel !== '' || mapEmployee.optionValue !== ''
      })

    return options
  })

  const employeeOptionsObjectValue = computed((): DropdownOption<EmployeeDynamic>[] => {
    const options: DropdownOption<EmployeeDynamic>[] = employees.value.map((employee) => {
      const mapDropdownOption: DropdownOption<EmployeeDynamic> = {
        icon: AvatarInitials,
        image: getEmployeeImageUrl(employee.image, customAPIStore.showEmployeeImage) ?? undefined,
        optionLabel: employee.employee_name ?? '',
        optionValue: employee,
      }

      return mapDropdownOption
    })

    return options
  })

  const fetchEmployees = async (fields?: EmployeeListParameterList): Promise<void> => {
    const newEmployeeList: EmployeeDynamic[] = await customAPIStore.getDocListEmployee(fields)

    employees.value = newEmployeeList.sort((current, next) => {
      return current.employee_name?.localeCompare(next.employee_name ?? '') ?? 0
    })
  }

  onMounted(async () => {
    await fetchEmployees()
  })

  return {
    employeeOptions,
    employeeOptionsObjectValue,
    employees,
    fetchEmployees,
  }
}

export { useEmployeeOptions }
